import { ReducersTypes } from '../Constants';


export const setSelectedFilters = (data) => ({
  type: ReducersTypes.SETSELECTEDFILTERS,
  payload: data,
});

export const removeSelectedFilters = () => ({
  type: ReducersTypes.REMOVESELECTEDFILTERS,
});
